import { render, staticRenderFns } from "./recognition.vue?vue&type=template&id=93c7373a&scoped=true"
import script from "./recognition.vue?vue&type=script&lang=js"
export * from "./recognition.vue?vue&type=script&lang=js"
import style0 from "./recognition.vue?vue&type=style&index=0&id=93c7373a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c7373a",
  null
  
)

export default component.exports